/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ws_Continue_AllInputs */

const en_ws_continue_all = /** @type {(inputs: Ws_Continue_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all`)
};

const id_ws_continue_all = /** @type {(inputs: Ws_Continue_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat semua`)
};

/**
* | output |
* | --- |
* | "See all" |
*
* @param {Ws_Continue_AllInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const ws_continue_all = /** @type {((inputs?: Ws_Continue_AllInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Continue_AllInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_ws_continue_all(inputs)
	return en_ws_continue_all(inputs)
});